module["exports"] = [
  "سپرده",
  "برداشت از حساب",
  "پرداخت",
  "صورتحساب"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/finance/transaction_type.js
// module id = 2937
// module chunks = 1609